import imageGalleryReducer from "@configuratorware/configurator-frontendgui/App/Reducers/ImageGallery/Reducer";
import { actions } from "./Actions";

export default function (state, action) {

    switch (action.type) {

        case actions.SET_IMAGE_NOTE: {
            return {
              ...state,
              selectedImage: {
                ...state.selectedImage,
                note: action.note
              }
            }
        }

    }
    return imageGalleryReducer(state, action);
}
